import { createContext, useContext, useMemo } from 'react';
import { isMobileOnly } from 'react-device-detect';

import childrenPropType from '@constants/childrenPropType';
import useAppScale from '@hooks/useAppScale';

const shellStyle = {
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  position: 'relative'
};

const identityWrapperStyle = {
  transform: 'none',
  transformOrigin: 'top left',
  width: '100%',
  height: '100%',
  display: 'block'
};

const createWrapperStyle = scale => {
  const safeScale = scale === 0 ? 1 : scale;
  if (safeScale === 1) {
    return identityWrapperStyle;
  }

  const invertedScalePercent = (1 / safeScale) * 100;

  return {
    transform: `scale(${safeScale})`,
    transformOrigin: 'top left',
    width: `${invertedScalePercent}%`,
    height: `${invertedScalePercent}%`,
    display: 'block'
  };
};

export const AppScaleContext = createContext(1);

export const useAppScaleValue = () => useContext(AppScaleContext);

export default function AppScaleWrapper({ children }) {
  const scale = useAppScale();
  const targetScale = isMobileOnly ? 1 : scale;
  const safeScale = targetScale || 1;

  const contextValue = useMemo(() => safeScale, [safeScale]);
  const wrapperStyles = useMemo(
    () => createWrapperStyle(safeScale),
    [safeScale]
  );

  return (
    <AppScaleContext.Provider value={contextValue}>
      <div style={shellStyle}>
        {/* Always render wrapper to avoid remounting consumers when scale toggles */}
        <div style={wrapperStyles}>{children}</div>
      </div>
    </AppScaleContext.Provider>
  );
}

AppScaleWrapper.propTypes = {
  children: childrenPropType
};

AppScaleWrapper.defaultProps = {
  children: null
};
